const map = {
	"./bg-sc.jpg": 39990,
	"./bg-tc.jpg": 28587,
	"./card-sc.jpg": 50635,
	"./card-tc.jpg": 62038,
	"./display-area-tall.png": 45638,
	"./display-area.png": 93980,
	"./tall-bg-sc.jpg": 7234,
	"./tall-bg-tc.jpg": 44831
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30004;